type calculateDiscountType = {
  amount: number
  flat?: number
  percent?: number
  min?: number
}
export const calculateDiscount = ({
  amount,
  flat,
  percent,
  min,
}: calculateDiscountType): number => {
  if (min && amount < min) {
    return
  }
  let discount = 0
  if (flat) {
    discount = flat
  }
  if (percent) {
    discount = (amount * percent) / 100
  }
  return discount
}
